import _ from 'helpers/no_conflict_lodash';

function getAttributes(node, filter) {
  const attributes = {};

  for (let i = 0; i < node.attributes.length; i++) {
    const attribute = node.attributes[i];
    const result = filter(attribute);
    if (result) {
      attributes[result.name] = result.value;
    }
  }

  return attributes;
}

export function parseStyleString(string) {
  if (!string) {
    return {};
  }

  const styles = string.split(';').map((style) => {
    const [name, value] = style.split(':');
    return { name, value };
  });

  return styles.filter(style => style.name && style.value).reduce((styles, style) => {
    styles[_.camelCase(style.name)] = style.value.trim();
    return styles;
  }, {});
}

export const getBuildoutAttributes = node => getAttributes(node, ({ name, value }) => {
  if (/^bo-/.test(name)) {
    return { name, value };
  }
});

export const getStandardAttributes = node => getAttributes(node, ({ name, value }) => {
  if (/^bo-/.test(name)) {
    return;
  }

  if (name === 'cellpadding') {
    name = 'cellPadding';
  } else if (name === 'cellspacing') {
    name = 'cellSpacing';
  } else if (name === 'class') {
    name = 'className';
  } else if (name === 'style') {
    value = parseStyleString(value);
  }

  return { name, value };
});
